export default __webpack_public_path__ + "static/media/1_3.7aae364f.png";